import { Link } from "react-router-dom";
import StartShell from "./StartShell";

export default function NewSite() {
  return (
    <StartShell title="Create a website" subtitle="Choose how you’d like to get started.">
      <div className="stack" style={{ gap: 16 }}>
        <Link to="/start/business" className="admin-card">
          <strong>Find my business</strong>
          <span>Find your business and review its details before building.</span>
        </Link>
        <Link to="/start/scratch" className="admin-card">
          <strong>Build from scratch</strong>
          <span>Walk through your business, content, and website preferences.</span>
        </Link>
      </div>
    </StartShell>
  );
}
